import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Toggle from 'react-toggle';
import Select from 'react-select';

import { Link, Redirect } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class EffectivenessSectionsEdit extends Component {
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      fatigue_data: {},
      section_fields: {},
      applicabilities_list: [],
      types_list: [
        { value: 'integer', label: this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.opcoesTipos.Quantidade },
        { value: 'time', label: this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.opcoesTipos.Tempo },
      ],
      automation_types_list: [],
      type: '',
      name: '',
      applicability_id: '',
      automation_type_id: '',
      required: 0,
      automatic_field: 0,
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.addEffectivenessSectionField = this.addEffectivenessSectionField.bind(this);
    this.edit = this.edit.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/secao-de-efetividade/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.section.id,
            name: responseJson.data.section.name,
            applicabilities_list: responseJson.data.applicabilities_list,
            applicability_id: responseJson.data.section.applicability_id,
            section_fields: responseJson.data.section_fields,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      applicability_id: this.state.applicability_id,
      applicability_name: this.state.applicability_name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/secao-de-efetividade', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  addEffectivenessSectionField(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      name: this.state.section_field_name,
      points: this.state.points,
      fatigue_id: this.state.id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/secao-de-efetividade/parametros', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var data_temp = self.state.section_fields;
          data_temp.push(responseJson.data);
          self.setState({section_fields: data_temp});
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var section_field_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/secao-de-efetividade/parametros/' + section_field_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(section_field_id);
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteRow(section_field_id) {
    var data = this.state.section_fields;
    data.map(function(dado, index){
      if (dado.id == section_field_id) {
        data.splice(index, 1);
      }
    });
    this.setState({section_fields: data});
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.titulo}</h3>
      <Link to="/parametros-de-fadiga" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formulario.placeholder.NomeDaSecaoDeEfetividade} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formulario.Aplicabilidade}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formulario.placeholder.SelecionarCliente}
                onChange={this.handleSelectChange.bind(this, 'applicability')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
        </div>


        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
          </div>
        </div>
      </form>
      <div>
        <hr/>
        <h3>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.tituloAdicionarParametrosDaSecao}</h3>
        <hr/>
        <div>
            <form onSubmit={this.addEffectivenessSectionField}>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.Nome}:</label>
                            <input type="text" name="section_field_name" className="form-control" placeholder={this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.placeholder.NomeDaSecaoDeEfetividade} value={this.state.section_field_name} onChange={this.handleChange.bind(this, 'section_field_name')} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.Tipo}:</label>
                            <Select
                                className="form-field-name"
                                name="type"
                                value={this.state.type}
                                searchable={true}
                                placeholder={this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.placeholder.SelecionarTipoDoCampo}
                                onChange={this.handleSelectChange.bind(this, 'type')}
                                options={this.state.types_list}
                            />
                        </div>
                    </div>
                </div>  
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.ParametroObrigatorio}?</label>
                            <br/>
                            <Toggle
                                checked={this.state.required}
                                aria-label='No label tag'
                                name="required"
                                onChange={this.handleToggleChange.bind(this, 'required')} />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.ParametroAutomatico}?</label>
                            <br/>
                            <Toggle
                                checked={this.state.automatic_field}
                                aria-label='No label tag'
                                name="extra_hours"
                                onChange={this.handleToggleChange.bind(this, 'automatic_field')} />
                        </div>
                    </div>
                    {(this.state.automatic_field === 1) ?
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.TipoDeAutomacao}:</label>
                                <Select
                                className="form-field-name"
                                name="automation_type"
                                value={this.state.automation_type_id}
                                searchable={true}
                                placeholder={this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.formularioAdicionarParametrosDaSecao.placeholder.SelecionarTipo}
                                onChange={this.handleSelectChange.bind(this, 'automation_type_id')}
                                options={this.state.automation_types_list}
                                />
                            </div>
                        </div>
                        : ''
                    }
                </div>
                <div className="row">
                    <div className="col-md-12">
                    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
                    </div>
                </div>
            </form>
        </div>
        <hr/>
        <h4>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.tituloParametrosDaSecao}</h4>
        <table className="table">
            <thead>
            <tr>
                <th>
                #
                </th>
                <th>
                {this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.tabela.Nome}
                </th>
                <th>
                {this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.tabela.Automatico}?
                </th>
                <th className='col-md-1'>{this.locale.ParametrosDeFadigas.EditarParametroDeFadiga.tabela.Acoes}</th>
            </tr>
            </thead>
            <tbody id="frotas">
            {Object.keys(self.state.section_fields).map(function(k) {
                return (
                <tr>
                    <td>
                    {self.state.section_fields[k].id}
                    </td>
                    <td>
                    {self.state.section_fields[k].field_name}
                    </td>
                    <td>
                    {self.state.section_fields[k].automatic_field}
                    </td>
                    <td>
                    <button className="btn btn-sm btn-danger" value={self.state.section_fields[k].id} onClick={self.delete}>
                        <i className="fa fa-fw fa-trash"></i>
                    </button>
                    </td>
                </tr>
                );
            })}
            </tbody>
        </table>
      </div>        
      
    </div>
  </div>
</div>
    );
  }
}

export default EffectivenessSectionsEdit;



// WEBPACK FOOTER //
// ./src/Components/EffectivenessSections/EffectivenessSectionsEdit.js